import React, { Fragment } from 'react';
import '../Menu/Menu.css';

const BtnEditar = ({ click, customClass }) => {
    return (<Fragment>
        <button
            type="button"
            onClick={click}
            className={customClass ? customClass : "botonEditar"}
            data-toggle="tooltip"
            data-placement="top"
            data-html2canvas-ignore>
            <i className="fas fa-pencil-alt"></i>
        </button>
    </Fragment>)
}
export default BtnEditar;